export default __webpack_public_path__ + "static/media/icon-hint.547e30ae.png";